/**
 * The following constants are used for tagging that enables automation and cost management, and facilitates
 * troubleshooting and routine maintenance.
 * @see https://wiki.cvent.com/display/CloudOps/Tagging+Standards#118638419280b226c765f41eba80c6d18c90dd7f0
 */
// Identifier to reference the business unit in the downstream tools.
export const BUSINESS_UNIT = 'event';
// Unique identifier to reference the application that is sending the action to the downstream tools
export const COMPONENT = 'attendee-hub-web';
